/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import "../assets/stylesheets/app.scss";
import { renderApplication, preRenderApplication } from "./render";
import { incrementPremiumStoriesRead } from "../isomorphic/paywall";
import { fetchLoggedInUser, fetchPaywallAttributes } from "../isomorphic/api";

import wretch from "wretch";

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

const CUSTOM_REDUCERS = {
  user(state = null, action) {
    switch (action.type) {
      case "ADD_USER":
        return { ...action.user };
      default:
        return state;
    }
  },
  storiesCounter(state = { remainingStoriesCount: null }, action) {
    switch (action.type) {
      case "UPDATE_STORIES_READ_STATS":
        return { remainingStoriesCount: action.remainingStoriesCount };
      default:
        return state;
    }
  }
};

global.wretch = wretch;

global.qtNoAutomaticGATracking = true;

global.userPromise = Promise.all([fetchLoggedInUser(), incrementPremiumStoriesRead()]).then(([user]) => {
  if (user && user.userId && global.navigator && global.navigator.sendBeacon) {
    global.navigator.sendBeacon(`/api/vikatan/v1/ping-user/${user.userId}`);
  }
  return user;
});

Promise.resolve(fetchPaywallAttributes()).then(function(res) {
  global.paywallPromise = res;
});

startApp(renderApplication, CUSTOM_REDUCERS, {
  enableServiceWorker: process.env.NODE_ENV === "production",
  enableFCM: true,
  appVersion: require("../isomorphic/app-version"),
  preRenderApplication
}).then(enableHotReload);
